// Activity events emitted by content/reactions.
//
// Subject of every reaction event is the ARTICLE (`subjectKind='article'`,
// `subjectId=<articleId>`), not the reaction row — reactions are not
// addressable resources, and downstream subscribers (notifications,
// future analytics, future digest) want to group by article.
//
// `previousKind` is included on `reaction-set` so a notification
// dispatcher can distinguish "first reaction" from "changed reaction"
// and dedupe accordingly (a user toggling between emojis shouldn't fire
// six author-pings in 30 seconds).
import { z } from 'zod';
import { ArticleReactionKind } from './reaction.js';
export const REACTION_ACTIVITY_KINDS = {
    Set: 'article.reaction-set',
    Cleared: 'article.reaction-cleared',
};
export const REACTION_ACTIVITY_KIND_GLOB = 'article.reaction-*';
const Iso = z.string().datetime({ offset: true });
export const ArticleReactionSetEvent = z.object({
    type: z.literal('article.reaction-set'),
    articleId: z.string().uuid(),
    /** The reacting user. Activity actor is the same id; surfaced on the
     *  payload too so subscribers don't need to read `event.actorId`. */
    userId: z.string().uuid(),
    kind: ArticleReactionKind,
    /** Null when the user had no prior reaction; non-null + different
     *  from `kind` when they're switching kinds. The notification
     *  subject can use this to skip "you got a new reaction" pings on
     *  rapid kind toggles. */
    previousKind: ArticleReactionKind.nullable(),
    occurredAt: Iso,
});
export const ArticleReactionClearedEvent = z.object({
    type: z.literal('article.reaction-cleared'),
    articleId: z.string().uuid(),
    userId: z.string().uuid(),
    /** The kind that was cleared. Null only when the call was idempotent
     *  (no prior row); we still emit so audit + analytics see the intent. */
    previousKind: ArticleReactionKind.nullable(),
    occurredAt: Iso,
});
//# sourceMappingURL=events.js.map